import Cassette from "../components/Cassette";

export default function Landing({ onStart }) {
  return (
    <div className="landing">
      <Cassette />

      <button className="play-btn" onClick={onStart}>
        ▶ PLAY
      </button>

      <p className="subtitle">Now Playing: Final scene</p>
    </div>
  );
}
